<template>
	<div>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search">
			<el-form-item class="btnList">
				<el-button size="small" type="primary" icon="el-icon-search" @click="inputChange()">搜索</el-button>
			</el-form-item>
		</el-form>
		<div style="text-align: center">
			<h1>近30天系统人员登录次数统计</h1>
		</div>
		<!--列表-->
		<el-table :cell-class-name="$moneyCellClass"
			v-loading="loading"
			:data="listData"
			:row-key="chName"
			height="calc(100vh - 360px)"
			border
			stripe
			empty-text="暂无数据"
			:header-cell-style="{ borderColor: '#01e3ed', backgroundColor: '#b3e0ff' }"
			:cell-style="{ 'border-right': '1px solid #01e3ed' }"
		>
			<el-table-column align="center" type="index" label="序号" width="60"></el-table-column>
			<el-table-column align="center" prop="chName" label="姓名" width="250"></el-table-column>
			<el-table-column v-for="(item, index) in listColumns" :key="index" align="center" :prop="`loginCount[${index}]`" :label="item" width="110"></el-table-column>
			<el-table-column align="center" prop="totalCount" label="合计" width="120" fixed="right"></el-table-column>
		</el-table>
	</div>
</template>

<script>
import { GetUserLoginLogStatistic } from "@/api/userApi.js";

export default {
	data() {
		return {
			loading: false, // 显示加载
			formInline: {
				days: 30
			},
			listData: [],
			listColumns: []
		};
	},
	// 注册组件
	components: {},
	/**
	 * 创建完毕
	 */
	created() {
		this.getListData();
	},
	computed: {},
	/**
	 * 里面的方法只有被调用才会执行
	 */
	methods: {
		// 查询
		inputChange() {
			this.getListData();
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetUserLoginLogStatistic(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.listData = res.data.dtls;
						this.listColumns = res.data.listColumns;
					} else {
						this.$message({
							type: "info",
							message: "暂无数据"
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>

<style scoped>
.year {
	color: #409eff;
	position: absolute;
	left: -166px;
	top: 1px;
}
</style>
